import {
  useResponsive,
  useAuthContext,
  useCookieConsent,
  BuyerOrgInitiative,
} from '@emfood/shared';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { hideScroll } from 'src/theme/css';

import Logo from 'src/components/logo';
import { NavSectionMini } from 'src/components/nav-section';

import { useNavData } from './config-navigation';
import { NAV, COOKIE_BANNER } from '../config-layout';
import NavToggleButton from '../common/nav-toggle-button';
import NavFeedbackButton from '../common/nav-feedback-button';

// ----------------------------------------------------------------------

const NavLogo = () => {
  const { user } = useAuthContext();
  const { buyerOrg } = user || {};

  return (
    <Logo
      sx={{ mx: 'auto', my: 2, minWidth: '50px' }}
      source="/logo/EqmLogo.png"
      height="auto"
      alt="AgileChain Leaf logo"
    />
  );
};

export default function NavMini() {
  const user = {} as any;
  const navData = useNavData();
  const { shouldDisplayCookieBanner } = useCookieConsent();
  const smDown = useResponsive('down', 'sm');
  return (
    <Box
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_MINI },
        backgroundColor: 'background.paper',
      }}
    >
      <NavToggleButton
        sx={{
          backgroundColor: 'background.paper',
          ...(!shouldDisplayCookieBanner
            ? {}
            : {
                mt: smDown ? COOKIE_BANNER.MOBILE : COOKIE_BANNER.DESKTOP,
              }),
          top: 22,
          left: NAV.W_MINI - 12,
        }}
      />

      <Stack
        sx={{
          pb: 2,
          height: 1,
          position: 'fixed',
          width: NAV.W_MINI,
          borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          ...hideScroll.x,
        }}
      >
        <NavLogo />
        <NavSectionMini
          data={navData}
          slotProps={{
            currentRole: user?.role,
          }}
        />

        <Box sx={{ flexGrow: 1 }} />

        <NavFeedbackButton mini />
      </Stack>
    </Box>
  );
}
